<template>
    <section class="section">
        <div class="container">
            <PageHeader title="СМС статистика">
                <div class="level-item">
                    <button class="button is-link" :class="{'is-loading':refreshing}" @click="fetchStats(true)">
                        <span class="icon"><i class="fa fa-refresh"></i></span>
                        <span>Освежи</span>
                    </button>
                </div>
            </PageHeader>

            <div class="columns is-multiline is-mobile">
                <div class="column is-half-mobile has-text-centered">
                    <p class="heading">Чекаат</p>
                    <p class="title" v-if="stats">{{stats.queue.pending.toLocaleString('mk')}}</p>
                    <Loading v-else/>
                </div>
                <div class="column is-half-mobile has-text-centered">
                    <p class="heading">Кај телефон</p>
                    <p class="title" v-if="stats">{{stats.queue.claimed.toLocaleString('mk')}}</p>
                    <Loading v-else/>
                </div>
                <div class="column is-half-mobile has-text-centered">
                    <p class="heading">Пратени</p>
                    <p class="title" v-if="stats">{{stats.queue.sent.toLocaleString('mk')}}</p>
                    <Loading v-else/>
                </div>
                <div class="column is-half-mobile has-text-centered">
                    <p class="heading">Неуспешни</p>
                    <p class="title" :class="{'has-text-danger':stats.queue.failed > 0}" v-if="stats">
                        {{stats.queue.failed.toLocaleString('mk')}}
                    </p>
                    <Loading v-else/>
                </div>
            </div>

            <div class="box" v-if="stats">
                <div class="columns is-mobile has-text-centered">
                    <div class="column">
                        <p class="heading">Пратени денес</p>
                        <p class="title is-4">{{stats.today.sent.toLocaleString('mk')}}</p>
                    </div>
                    <div class="column">
                        <p class="heading">Неуспешни денес</p>
                        <p class="title is-4" :class="{'has-text-danger':stats.today.failed > 0}">
                            {{stats.today.failed.toLocaleString('mk')}}
                        </p>
                    </div>
                    <div class="column">
                        <p class="heading">Последна порака</p>
                        <p class="title is-6" v-if="stats.last_sent_at">{{stats.last_sent_at | moment("from")}}</p>
                        <p class="title is-6 has-text-grey" v-else>—</p>
                    </div>
                </div>
            </div>

            <div class="mb-6 mt-6"></div>

            <h4 class="title is-5">Телефони денес</h4>
            <table class="table is-fullwidth is-striped is-hoverable" v-if="stats">
                <thead>
                <tr>
                    <th>Телефон</th>
                    <th class="has-text-right">Пратени</th>
                    <th class="has-text-right">Неуспешни</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="device in stats.devices" :key="device.user_id">
                    <td>
                        <span class="icon"><i class="fa fa-mobile"></i></span>
                        <span>{{device.name}}</span>
                    </td>
                    <td class="has-text-right">{{device.sent.toLocaleString('mk')}}</td>
                    <td class="has-text-right" :class="{'has-text-danger':device.failed > 0}">
                        {{device.failed.toLocaleString('mk')}}
                    </td>
                </tr>
                <tr v-if="stats.devices.length === 0">
                    <td colspan="3" class="has-text-grey has-text-centered">Нема активност денес</td>
                </tr>
                </tbody>
            </table>
            <Loading v-else/>

            <div class="mb-6 mt-6"></div>

            <h4 class="title is-5">Последни неуспешни</h4>
            <table class="table is-fullwidth is-striped is-hoverable" v-if="stats">
                <thead>
                <tr>
                    <th>Број</th>
                    <th>Грешка</th>
                    <th class="has-text-right">Обиди</th>
                    <th class="has-text-right">Кога</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="message in stats.recent_failures" :key="message.id">
                    <td>{{message.recipient}}</td>
                    <td class="has-text-danger">{{message.error || "—"}}</td>
                    <td class="has-text-right">{{message.attempts}}</td>
                    <td class="has-text-right" v-if="message.sent_at">{{message.sent_at | moment("DD.MM.YYYY HH:mm")}}</td>
                    <td class="has-text-right has-text-grey" v-else>—</td>
                    <td class="has-text-right">
                        <div class="buttons is-right are-small" v-if="discarding === message.id">
                            <button class="button is-danger" :class="{'is-loading':busy === message.id}"
                                    @click="discard(message)">
                                Потврди отфрлање
                            </button>
                            <button class="button" :disabled="busy === message.id" @click="discarding = null">
                                Назад
                            </button>
                        </div>
                        <div class="buttons is-right are-small" v-else>
                            <button class="button is-link is-light" :class="{'is-loading':busy === message.id}"
                                    :disabled="busy !== null" @click="retry(message)">
                                <span class="icon"><i class="fa fa-repeat"></i></span>
                                <span>Повторно</span>
                            </button>
                            <button class="button is-danger is-light" :disabled="busy !== null"
                                    @click="discarding = message.id">
                                <span class="icon"><i class="fa fa-trash"></i></span>
                                <span>Отфрли</span>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr v-if="stats.recent_failures.length === 0">
                    <td colspan="5" class="has-text-grey has-text-centered">Нема неуспешни пораки</td>
                </tr>
                </tbody>
            </table>
            <Loading v-else/>
        </div>
    </section>
</template>

<script>
    import Loading from "../components/Loading";

    // pending/claimed move while a phone is working through a batch, so the page
    // re-polls instead of showing a number that went stale the moment it loaded.
    const REFRESH_INTERVAL = 30000;

    export default {
        name: "Sms",
        components: {Loading},
        data() {
            return {
                stats: null,
                refreshing: false,
                timer: null,
                // Id of the failure an action is running on, and of the one waiting for
                // its discard to be confirmed. Both also hold the poll off (see fetchStats).
                busy: null,
                discarding: null,
            }
        },
        methods: {
            fetchStats(manual = false) {
                // A poll landing mid-action would re-render the failures table and move the
                // row out from under the cursor, so the timer waits until the row is settled.
                if (!manual && (this.busy !== null || this.discarding !== null)) return;
                if (manual) this.refreshing = true;
                this.$http.get("/stats/sms")
                    .then(a => {
                        // The api interceptor resolves with undefined on a handled error;
                        // keep the last good numbers on screen instead of blanking them.
                        if (!a) return;
                        this.stats = a.data.data;
                    })
                    .finally(() => this.refreshing = false)
            },
            retry(message) {
                this.busy = message.id;
                this.$http.post(`/messages/${message.id}/retry`)
                    .then(res => {
                        if (!res) return; // cancelled request
                        this.$toast({type: "is-success", message: "Пораката е вратена во ред"});
                    })
                    .finally(() => {
                        this.busy = null;
                        this.discarding = null;
                        this.fetchStats();
                    })
            },
            discard(message) {
                this.busy = message.id;
                this.$http.delete(`/messages/${message.id}`)
                    .then(res => {
                        if (!res) return;
                        this.$toast({type: "is-success", message: "Пораката е отфрлена"});
                    })
                    .finally(() => {
                        this.busy = null;
                        this.discarding = null;
                        this.fetchStats();
                    })
            }
        },
        created() {
            this.fetchStats();
            this.timer = setInterval(this.fetchStats, REFRESH_INTERVAL);
        },
        beforeDestroy() {
            clearInterval(this.timer);
        }
    }
</script>
